"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var CPPFormatter_1 = require("./CPPFormatter");
var CPPWritableObject_1 = require("./CPPWritableObject");

var CPPVariable = function () {
    function CPPVariable(dataType, variableName, variableValue) {
        _classCallCheck(this, CPPVariable);

        this.dataType = dataType;
        this.variableName = variableName;
        this.variableValue = variableValue;
    }

    _createClass(CPPVariable, [{
        key: "getDataType",
        value: function getDataType() {
            return this.dataType;
        }
    }, {
        key: "setDataType",
        value: function setDataType(value) {
            this.dataType = value;
            return this;
        }
    }, {
        key: "getVariableName",
        value: function getVariableName() {
            return this.variableName;
        }
    }, {
        key: "setVariableName",
        value: function setVariableName(value) {
            this.variableName = value;
            return this;
        }
    }, {
        key: "getVariableValue",
        value: function getVariableValue() {
            return this.variableValue;
        }
    }, {
        key: "setVariableValue",
        value: function setVariableValue(value) {
            this.variableValue = value;
            return this;
        }
    }, {
        key: "write",
        value: function write(formatter) {
            var indentCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            var output = this.dataType + " " + this.variableName;
            if (this.variableValue) {
                output += " = " + this.variableValue;
            }
            output += ';';
            if (indentCount > 0) {
                output = formatter.indentation.repeat(indentCount) + output;
            }
            return output;
        }
    }], [{
        key: "createBoolean",
        value: function createBoolean(name, value) {
            return this.createVariable('bool', name, value, value ? 'true' : 'false');
        }
    }, {
        key: "createInt",
        value: function createInt(name, value) {
            return this.createVariable('int', name, value);
        }
    }, {
        key: "createDouble",
        value: function createDouble(name, value) {
            return this.createVariable('double', name, value);
        }
    }, {
        key: "createFloat",
        value: function createFloat(name, value) {
            return this.createVariable('float', name, value);
        }
    }, {
        key: "createConstChar",
        value: function createConstChar(name, value) {
            return this.createVariable('const char*', name, value, "\"" + value + "\"");
        }
    }, {
        key: "createString",
        value: function createString(name, value) {
            return this.createVariable('std::string', name, value, "\"" + value + "\"");
        }
    }, {
        key: "createVariable",
        value: function createVariable(type, name, rawValue, literalValue) {
            var evaluatedValue = null;
            if (rawValue == null) {
                return new CPPVariable(type, name);
            } else if (rawValue instanceof CPPVariable) {
                evaluatedValue = rawValue.getVariableName();
            } else if (rawValue instanceof CPPWritableObject_1.default) {
                evaluatedValue = rawValue.write(new CPPFormatter_1.default());
                evaluatedValue = evaluatedValue.replace(/;$/, '');
            }
            return new CPPVariable(type, name, evaluatedValue || literalValue || rawValue);
        }
    }]);

    return CPPVariable;
}();

exports.default = CPPVariable;